import type { WhoopHealthSummary } from '../services/api';

export function isConnectedWhoopHealth(value: unknown): value is WhoopHealthSummary {
  if (value === null || typeof value !== 'object') return false;

  const candidate = value as Partial<WhoopHealthSummary>;
  return candidate.provider === 'whoop' && candidate.connected === true;
}
